import { FoundationWorkContentDiariseReasonFModel } from "e5core-angular-services/lib/models/e5.data.models";

export class DiariseReasonModel {
	reason: string;
	id: number; 
	code:string;	
	constructor(item: FoundationWorkContentDiariseReasonFModel) {
		this.id = item.id;
		this.code = item.code;
		this.reason = item.reason;
    }
}